import { render, staticRenderFns } from "./DownloadSettingsModal.vue?vue&type=template&id=4a00ea2e&scoped=true&"
import script from "./DownloadSettingsModal.vue?vue&type=script&lang=js&"
export * from "./DownloadSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./DownloadSettingsModal.vue?vue&type=style&index=0&id=4a00ea2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a00ea2e",
  null
  
)

export default component.exports